module.exports = __webpack_public_path__ + "img/logo.d227cf8b.png";